import { createRequest } from '../../Api';
import get from 'lodash/get';
import i18n from '../../i18n';

export const REQUEST_ERROR = 'CONFIGURATION_REQUEST_ERROR';
export const SEND_REQUEST_OFFER = 'OFFER_SEND_REQUEST_OFFER';
export const RECEIVE_REQUEST_OFFER = 'OFFER_RECEIVE_REQUEST_OFFER';
export const RESET_REQUEST_OFFER = 'OFFER_RESET_REQUEST_OFFER';
export const RESET_ERROR = 'OFFER_RESET_ERROR';

export const createRequestError = (e) => ({
  type: REQUEST_ERROR,
  error: e,
});

export const receiveRequestOffer = (response) => ({
  type: RECEIVE_REQUEST_OFFER,
  response,
});

export const resetRequestOffer = () => ({
  type: RESET_REQUEST_OFFER,
});

export const resetError = () => ({
  type: RESET_ERROR,
});

export const sendRequestOffer = (configurationCode, formData) => async (dispatch, getState) => {
  const { request } = createRequest();
  try {
    const response = await request({
      method: 'post',
      url: `/frontendapi/configurations/${configurationCode}/offer`,
      data: {
        isRental: formData.isRental.value,
        firstName: formData.firstname.value,
        name: formData.name.value,
        company: formData.company.value,
        phoneNumber: formData.tel.value,
        email: formData.email.value,
        intendedLocation: formData.address.value,
        comment: formData.message.value,
        postalCode: formData.postalCode.value,
      },
    });

    const price = get(response, 'data.price', 0);
    const country = getState().Country.selectedCountry;
    const dataLayer = window.dataLayer;
    if (price && dataLayer) {
      dataLayer.push({
        event: 'Conversion-Inquiry',
        language: i18n.language,
        value: price,
        country,
      });
    }

    dispatch(receiveRequestOffer(response));
  } catch (e) {
    dispatch(createRequestError(e));
  }
};
